<template>
     <back-layout title="Mensagens">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Mensagens
            </h2>
        </template>

        <div class="py-12">
            <div class="container mx-auto">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-10">
                   lista
                </div>
            </div>
        </div>
    </back-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
   

    export default defineComponent({
        components: {
            Head,
            Link,
            BackLayout,
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
        },
        data() {
            return {
            }
        },
        methods: {
        },
    })
</script>